import { adminPrefix } from "../../constants";

export const partnersApis = {
  FETCH_PARTNERS: adminPrefix + "partners",
  CREATE_PARTNER: adminPrefix + "partner/create",
  UPDATE_PARTNER: adminPrefix + "partner/update",
  DELETE_PARTNER: adminPrefix + "partner/delete",
  UPDATE_PARTNER_STATUS: adminPrefix + "partner/update-status",
};
